// Tell state where we are
export const ACTIVE_COMP = "activeComponent";
// User
export const CHECK_AUTH = "checkAuth";
export const LOGIN = "loginUser";
export const FETCH_USER = "fetchUser";
export const CREATE_EXPCLIENT_USER = 'createExpUser';
export const CHECK_PERM = 'checkUserPermission';
// Client
export const FETCH_EXPCLIENT = "fetchExpClient";
export const FETCH_EXPCLIENT_LIST = "fetchExpClients";
export const SET_ACTIVE_EXPCLIENT = "setActiveExpCLient";

export const TOGGLE_SHOW_FILTERS = "toggleShowFilters";
// Photo
export const PHOTOS_PUBLISH = "publishPhotos";
// Searching
export const PHOTO_SEARCH = 'photoSearch';
export const PHOTO_SEARCH_RESET = 'photoSearchReset';
export const PHOTO_UPDATE_RESULT_ITEM = 'photoSearchItemUpdate';
export const PHOTO_UPDATE_PUBLISH_STATE = 'photoSearchItemPublishState';

// Selecting
export const SELECT_ALL_PHOTO_REMOVE = 'selectAllPhotosRemove';
export const SELECT_ALL_PHOTO_ADD = 'selectAllPhotosAdd';

export const SELECT_PHOTO_REMOVE = 'collectionItemsRemove';
export const SELECT_PHOTO_ADD = 'collectionItemsAdd';
export const TOGGLE_SHOW_SELECTED = 'toggleShowSelected';
export const SELECTED_RESET = 'selectedReset';

// Collection
export const FETCH_COLLECTION = "fetchCollection";
export const FETCH_EXPCLIENT_COLLECTIONS = "fetchCollections";
export const COLLECTION_DELETE = "deleteCollection";
export const COLLECTION_CREATE = "createCollection";
export const COLLECTIONS_RESET_STATE = "resetCollections";
export const COLLECTIONS_REMOVE_COLLECTION = "colllectionRemove";
export const COLLECTION_ALTER_SHARE = "colllectionShareAlter";

//export const COLLECTION_SET_BY_INDEX
export const COLLECTION_SET_BY_OBJ = "collectionSetByObj";

export const COLLECTION_RESET_STATE = "resetCollection";

export const NEW_SEARCH_IDENTIFIER = "newSearchIdentifier";

